import { createTheme } from '@mui/material/styles';
import { baseTheme } from 'theme';
import { deepmerge } from '@mui/utils';

const theme = createTheme(baseTheme);

const datePickerTheme = createTheme(
  deepmerge(theme, {
    components: {
      MuiPopper: {
        styleOverrides: {
          root: {
            zIndex: 999999,
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: theme.palette.background.paper,
            borderRadius: '6px',
            padding: '8px',
            boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',

            '& .react-calendar': {
              border: '0',
              padding: '8px',

              '& button:hover': {
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.common.white,
              },
            },

            '& .react-calendar__navigation button': {
              fontSize: '16px',
              fontWeight: '600',
            },

            '& .react-calendar__tile--active:enabled:hover, & .react-calendar__tile--active:enabled:focus, & .react-calendar__tile--active':
              {
                backgroundColor: theme.palette.primary.main,
              },

            '& .react-calendar__month-view__weekdays': {
              color: theme.palette.primary.light,
            },
            '& .MuiButton-root': {
              justifyContent: 'left',
              color: theme.palette.text.primary,
              borderRadius: 0,
              fontSize: 12,
              ':hover': {
                color: theme.palette.secondary.main,
              },
            },
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            fontSize: '16px',
          },
        },
      },
    },
  }),
);
export default datePickerTheme;
